document.addEventListener('DOMContentLoaded', () => {

  const benefits = document.querySelectorAll('.asia24-benefit');

  const observer = new IntersectionObserver((entries)=>{

    entries.forEach(entry=>{

      if(entry.isIntersecting){
        entry.target.classList.add('visible');
      }

    });

  },{
    threshold:0.2
  });

  benefits.forEach(item=>{
    observer.observe(item);
  });

});